import { useState } from "react";
import { Volume2, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

function WordCard({ v, idx, story, narration }) {
  const [flipped, setFlipped] = useState(false);
  const [learned, setLearned] = useState(false);
  const learn = async () => {
    try {
      await api.post("/progress", { type: "vocab", story_id: story.id, score: idx });
      setLearned(true);
      toast.success(`Nouveau mot : « ${v.word} » !`);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <div data-testid={`vocab-card-${idx}`} className="rise card-paper flex flex-col p-6" style={{ animationDelay: `${idx * 70}ms` }}>
      <div className="flex items-center justify-between">
        <h3 className="font-display text-3xl font-bold text-[color:var(--terracotta)]">{v.word}</h3>
        <button data-testid={`vocab-listen-${idx}`} onClick={() => narration.play(`${v.word}. ${v.definition}`)} className="rounded-full bg-[color:var(--paper-2)] p-2.5 hover:bg-[color:var(--sun)]"><Volume2 size={20} /></button>
      </div>
      {flipped ? (
        <div className="mt-3 space-y-2">
          <p className="text-lg">{v.definition}</p>
          <p className="font-story italic text-[color:var(--muted-ink)]">« {v.example} »</p>
        </div>
      ) : (
        <button data-testid={`vocab-reveal-${idx}`} onClick={() => setFlipped(true)} className="mt-3 text-left font-bold text-[color:var(--sage)] underline">Qu'est-ce que ça veut dire ?</button>
      )}
      <button data-testid={`vocab-learned-${idx}`} disabled={learned} onClick={learn}
        className={`mt-5 flex items-center justify-center gap-2 rounded-full py-2 font-bold transition-colors ${learned ? "bg-[#E6F3EE] text-[color:var(--sage)]" : "bg-[color:var(--paper-2)] hover:bg-[color:var(--sun)]"}`}>
        <Check size={18} /> {learned ? "Mot appris" : "J'ai compris ce mot"}
      </button>
    </div>
  );
}

export default function Vocabulary({ story, narration }) {
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {(story.vocabulary || []).map((v, i) => <WordCard key={i} v={v} idx={i} story={story} narration={narration} />)}
    </div>
  );
}
